import { supabase } from '@/lib/supabase';
import type {
  TaskCommentsInsert,
  TaskCommentsRow,
} from '@/types/database.types';

export async function listComments(taskId: string): Promise<TaskCommentsRow[]> {
  const { data, error } = await supabase
    .from('task_comments')
    .select('*')
    .eq('task_id', taskId)
    .is('deleted_at', null)
    .order('created_at', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function addComment(input: TaskCommentsInsert): Promise<TaskCommentsRow> {
  const { data, error } = await supabase
    .from('task_comments')
    .insert(input)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function softDeleteComment(id: string): Promise<void> {
  const { error } = await supabase
    .from('task_comments')
    .update({ deleted_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}
